export const BE_BASE_URL = process.env.REACT_APP_BE_BASE_URL;